import React from 'react';

import SVGIcon, { GENERAL_ICONS } from 'src/components/svg';

import {
  lang,
  remCss,
  number,
  upperFirstChar,
  userFullName,
  scssVariables as variables
} from 'src/helpers';
import moment from 'moment';

const messages = {
  success: 'Your Payment is successfully done.',
  failed: 'We can’t process your payment.\n' + 'Please check your balance.'
};
export class PaymentNotice extends React.PureComponent {
  render() {
    const { item, status = 'failed' } = this.props;

    return (
      <div className={'mc-popup-contain'} style={{ width: remCss(400) }}>
        <div className={'mc-flex-15-col'}>
          <div className='mc-modal-header mc-flex-col mc-flex-center mc-plr20 mc-pb20'>
            <SVGIcon
              iconname={
                status === 'failed' ? GENERAL_ICONS.PAYMENT_FAIL : GENERAL_ICONS.PAYMENT_SUCCESS
              }
            />
            <div className='mc-title mc-mt5 '>
              {lang.t('Payment ' + upperFirstChar(status) + '!')}
            </div>
            <pre className='mc-value-418' style={{ textAlign: 'center' }}>
              {lang.t(messages[status])}
            </pre>
          </div>
          <div className={'mc-flex mc-mt15'}>
            <div className={'mc-grow mc-label-416'}>{lang.t('Amount')}</div>
            <div
              className={'mc-value-616'}
              style={{
                color: variables['colors-mc-' + (status === 'failed' ? 'error' : 'primary')]
              }}
            >
              {number.format(item.amount)} {item.currency} ({upperFirstChar(item.status)})
            </div>
          </div>
          <div className={'mc-flex'}>
            <div className={'mc-grow mc-label-416'}>{lang.t('Invoice no.')}</div>
            <div className={'mc-value-616'}>{item.invoiceNo}</div>
          </div>
          <div className={'mc-flex'}>
            <div className={'mc-grow mc-label-416'}>{lang.t('Sender name')}</div>
            <div className={'mc-value-616'}>{userFullName(item.sender)}</div>
          </div>
          <div className={'mc-flex'}>
            <div className={'mc-grow mc-label-416'}>{lang.t('Payment Method')}</div>
            <div className={'mc-value-616'}>{item.card && item.card.brand}</div>
          </div>
          <div className={'mc-flex'}>
            <div className={'mc-grow mc-label-416'}>{lang.t('Payment date')}</div>
            <div className={'mc-value-616'}>{moment(item.date).format('DD-MM-YYYY')}</div>
          </div>
          <div className={'mc-flex'}>
            <div className={'mc-grow mc-label-416'}>{lang.t('Payment time')}</div>
            <div className={'mc-value-616'}>{moment(item.date).format('hh:mm a')}</div>
          </div>
        </div>
      </div>
    );
  }
}
